import { InputHTMLAttributes, forwardRef } from 'react';
import clsx from 'clsx';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, label, error, helperText, id, ...props }, ref) => {
    const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');

    return (
      <div className="w-full">
        {label && (
          <label
            htmlFor={inputId}
            className="block text-sm font-medium mb-1"
            style={{ color: 'var(--wl-secondary)' }}
          >
            {label}
          </label>
        )}
        <input
          ref={ref}
          id={inputId}
          className={clsx(
            'block w-full px-3 py-2',
            'focus:outline-none focus:ring-2 focus:ring-offset-0',
            'disabled:cursor-not-allowed',
            className
          )}
          style={{
            borderRadius: '6px',
            border: error ? '1px solid #E5384F' : '1px solid #E6E6F0',
            color: 'var(--wl-secondary)',
            backgroundColor: props.disabled ? '#F6F6F8' : '#FFF',
            fontSize: '1rem',
            lineHeight: '1.5',
            transition: 'all 0.2s ease-in-out',
          }}
          onFocus={(e) => {
            if (!error) {
              e.currentTarget.style.borderColor = 'var(--wl-primary)';
              e.currentTarget.style.boxShadow = '0 0 0 2px var(--wl-primary-light)';
            }
          }}
          onBlur={(e) => {
            if (!error) {
              e.currentTarget.style.borderColor = '#E6E6F0';
              e.currentTarget.style.boxShadow = 'none';
            }
          }}
          {...props}
        />
        {error && (
          <p 
            className="mt-1 text-sm"
            style={{ color: '#E5384F' }}
          >
            {error}
          </p>
        )}
        {!error && helperText && (
          <p 
            className="mt-1 text-sm"
            style={{ color: '#6E6D7A' }}
          >
            {helperText}
          </p>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';
